// Mock data for Autodoc UK clone

export const carMakes = [
  { id: '1', name: 'Audi', logo: 'https://cdn.brandfetch.io/audi.com/w/400/h/400' },
  { id: '2', name: 'BMW', logo: 'https://cdn.brandfetch.io/bmw.com/w/400/h/400' },
  { id: '3', name: 'Ford', logo: 'https://cdn.brandfetch.io/ford.com/w/400/h/400' },
  { id: '4', name: 'Mercedes-Benz', logo: 'https://cdn.brandfetch.io/mercedes-benz.com/w/400/h/400' },
  { id: '5', name: 'Volkswagen', logo: 'https://cdn.brandfetch.io/vw.com/w/400/h/400' },
  { id: '6', name: 'Toyota', logo: 'https://cdn.brandfetch.io/toyota.com/w/400/h/400' },
  { id: '7', name: 'Honda', logo: 'https://cdn.brandfetch.io/honda.com/w/400/h/400' },
  { id: '8', name: 'Nissan', logo: 'https://cdn.brandfetch.io/nissan.com/w/400/h/400' },
  { id: '9', name: 'Peugeot', logo: 'https://cdn.brandfetch.io/peugeot.com/w/400/h/400' },
  { id: '10', name: 'Renault', logo: 'https://cdn.brandfetch.io/renault.com/w/400/h/400' }
];

export const carModels = {
  '1': ['A3', 'A4', 'A6', 'Q3', 'Q5', 'Q7'],
  '2': ['3 Series', '5 Series', 'X3', 'X5'],
  '3': ['Fiesta', 'Focus', 'Mondeo', 'Kuga'],
  '4': ['C-Class', 'E-Class', 'GLA', 'GLC'],
  '5': ['Golf', 'Polo', 'Passat', 'Tiguan'],
  '6': ['Corolla', 'Camry', 'RAV4', 'Yaris'],
  '7': ['Civic', 'Accord', 'CR-V', 'Jazz'],
  '8': ['Qashqai', 'Juke', 'X-Trail', 'Micra'],
  '9': ['208', '308', '3008', '5008'],
  '10': ['Clio', 'Megane', 'Captur', 'Kadjar']
};

export const carYears = Array.from({ length: 25 }, (_, i) => (2025 - i).toString());

export const categories = [
  { id: '1', name: 'Engine Parts', icon: 'Cog', count: 45230 },
  { id: '2', name: 'Brake System', icon: 'Disc', count: 32450 },
  { id: '3', name: 'Suspension', icon: 'Wrench', count: 28900 },
  { id: '4', name: 'Filters', icon: 'Filter', count: 15670 },
  { id: '5', name: 'Body Parts', icon: 'Car', count: 52340 },
  { id: '6', name: 'Electrics', icon: 'Zap', count: 38920 },
  { id: '7', name: 'Oil & Fluids', icon: 'Droplet', count: 8540 },
  { id: '8', name: 'Tyres & Wheels', icon: 'CircleDot', count: 12780 }
];

export const products = [
  {
    id: '1',
    name: 'Bosch Oil Filter',
    brand: 'Bosch',
    partNumber: 'F026407124',
    price: 8.99,
    originalPrice: 12.99,
    category: 'Filters',
    image: 'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=400&h=400&fit=crop',
    rating: 4.7,
    reviews: 342,
    inStock: true,
    description: 'High-quality oil filter for optimal engine protection',
    specifications: {
      'Filter Type': 'Spin-on',
      'Height': '90mm',
      'Diameter': '76mm',
      'Thread Size': 'M20 x 1.5'
    },
    compatibility: ['Audi A3', 'VW Golf', 'Seat Leon']
  },
  {
    id: '2',
    name: 'Brembo Brake Pads Set',
    brand: 'Brembo',
    partNumber: 'P85020',
    price: 45.99,
    originalPrice: 59.99,
    category: 'Brake System',
    image: 'https://images.unsplash.com/photo-1625047509168-a7026f36de04?w=400&h=400&fit=crop',
    rating: 4.9,
    reviews: 567,
    inStock: true,
    description: 'Premium brake pads for superior stopping power',
    specifications: {
      'Width': '144mm',
      'Height': '55mm',
      'Thickness': '18mm',
      'Wear Warning Contact': 'Incl. wear warning contact'
    },
    compatibility: ['BMW 3 Series', 'BMW 5 Series']
  },
  {
    id: '3',
    name: 'Mann Air Filter',
    brand: 'Mann-Filter',
    partNumber: 'C16134',
    price: 12.50,
    originalPrice: null,
    category: 'Filters',
    image: 'https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=400&h=400&fit=crop',
    rating: 4.6,
    reviews: 234,
    inStock: true,
    description: 'Original quality air filter for optimal engine performance',
    specifications: {
      'Length': '285mm',
      'Width': '213mm',
      'Height': '35mm',
      'Filter Type': 'Filter Insert'
    },
    compatibility: ['Ford Focus', 'Ford Mondeo']
  },
  {
    id: '4',
    name: 'Castrol Edge 5W-30 Oil',
    brand: 'Castrol',
    partNumber: '15669E',
    price: 34.99,
    originalPrice: 44.99,
    category: 'Oil & Fluids',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=400&fit=crop',
    rating: 4.8,
    reviews: 892,
    inStock: true,
    description: 'Advanced full synthetic engine oil - 5 Litre',
    specifications: {
      'Capacity': '5L',
      'Viscosity': '5W-30',
      'Specification': 'ACEA C3',
      'Type': 'Fully Synthetic'
    },
    compatibility: ['Universal']
  },
  {
    id: '5',
    name: 'NGK Spark Plugs Set',
    brand: 'NGK',
    partNumber: 'BKR6E',
    price: 16.99,
    originalPrice: null,
    category: 'Electrics',
    image: 'https://images.unsplash.com/photo-1625047508734-996a6e92e13c?w=400&h=400&fit=crop',
    rating: 4.7,
    reviews: 445,
    inStock: true,
    description: 'Premium spark plugs for reliable ignition - Set of 4',
    specifications: {
      'Thread Size': 'M14 x 1.25',
      'Spanner Size': '16mm',
      'Overall Length': '60.5mm',
      'Electrode Gap': '1.0mm'
    },
    compatibility: ['Toyota Corolla', 'Honda Civic']
  },
  {
    id: '6',
    name: 'Sachs Shock Absorber',
    brand: 'Sachs',
    partNumber: '310924',
    price: 52.99,
    originalPrice: 68.99,
    category: 'Suspension',
    image: 'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=400&h=400&fit=crop',
    rating: 4.8,
    reviews: 278,
    inStock: true,
    description: 'Gas pressure shock absorber for smooth ride',
    specifications: {
      'Shock Absorber Type': 'Gas Pressure',
      'Fitting Position': 'Front Axle',
      'Length': '345mm',
      'Piston Rod Diameter': '20mm'
    },
    compatibility: ['VW Passat', 'Audi A4']
  },
  {
    id: '7',
    name: 'Hella Headlight Assembly',
    brand: 'Hella',
    partNumber: '1EL354809-071',
    price: 189.99,
    originalPrice: 249.99,
    category: 'Body Parts',
    image: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=400&h=400&fit=crop',
    rating: 4.9,
    reviews: 156,
    inStock: false,
    description: 'Complete headlight assembly with H7 bulbs',
    specifications: {
      'Left/Right': 'Right',
      'Light Function': 'with indicator',
      'Lamp Type': 'H7/H7',
      'Lens Color': 'clear'
    },
    compatibility: ['Mercedes C-Class']
  },
  {
    id: '8',
    name: 'Michelin Pilot Sport 4',
    brand: 'Michelin',
    partNumber: '225/45R17',
    price: 89.99,
    originalPrice: null,
    category: 'Tyres & Wheels',
    image: 'https://images.unsplash.com/photo-1595420111688-bd0d7e0c31bf?w=400&h=400&fit=crop',
    rating: 4.9,
    reviews: 623,
    inStock: true,
    description: 'High-performance summer tyre',
    specifications: {
      'Width': '225mm',
      'Profile': '45',
      'Rim Diameter': '17"',
      'Load Index': '94',
      'Speed Rating': 'Y'
    },
    compatibility: ['Universal']
  }
];

export const reviews = [
  {
    id: '1',
    productId: '1',
    userName: 'John Smith',
    rating: 5,
    date: '2024-11-15',
    comment: 'Excellent quality filter, fits perfectly. Fast delivery!',
    verified: true
  },
  {
    id: '2',
    productId: '1',
    userName: 'Sarah Johnson',
    rating: 4,
    date: '2024-11-10',
    comment: 'Good product, slightly expensive but worth it.',
    verified: true
  },
  {
    id: '3',
    productId: '2',
    userName: 'Mike Brown',
    rating: 5,
    date: '2024-11-20',
    comment: 'Best brake pads I\'ve used. Significant improvement in braking performance.',
    verified: true
  }
];

export const featuredDeals = [
  {
    id: 'deal1',
    title: 'Winter Essentials',
    discount: '30% OFF',
    image: 'https://images.unsplash.com/photo-1609078880481-94b93a6044ce?w=800&h=400&fit=crop',
    products: ['Antifreeze', 'Wiper Blades', 'Battery']
  },
  {
    id: 'deal2',
    title: 'Service Kits',
    discount: 'Save up to £50',
    image: 'https://images.unsplash.com/photo-1487754180451-c456f719a1fc?w=800&h=400&fit=crop',
    products: ['Oil', 'Filters', 'Spark Plugs']
  }
];

export const brands = [
  'Bosch', 'Brembo', 'Castrol', 'Mann-Filter', 'NGK', 'Sachs', 'Hella', 'Michelin',
  'Continental', 'Valeo', 'Febi', 'SKF', 'TRW', 'Delphi', 'Mahle'
];
